import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import chunk from "lodash/chunk";
import forOwn from "lodash/forOwn";
import { RESULTADO_ACCION_MAIL } from "./types";

function resetListaColegios() {
  return actions.resetListaColegios();
}

function obtenerDatosPaginacion({
  itemsPorPagina,
  tipo,
  provinciaActiva,
  idColegio = null,
  localidadBuscada
}) {
  return dispatch => {
    switch (tipo) {
      case "general":
        dispatch(
          obtenerDatosPaginacionGeneral({
            itemsPorPagina,
            provinciaActiva,
            idColegio,
            localidadBuscada
          })
        );
        break;

      default:
        dispatch(obtenerDatosPaginacionPorTipo({ itemsPorPagina, tipo }));
        break;
    }
  };
}

function obtenerNombreColegios() {
  return dispatch =>
    rootRef.child("ventas/colegios_nombre").once("value", snap => {
      let data = [];
      forOwn(snap.val(), (colegio, clave) => {
        data.push(colegio);
      });
      dispatch(actions.obtenerNombreColegios(data));
    });
}

function limpiarNombreColegios() {
  return actions.limpiarNombreColegios();
}

function obtenerLocalidades() {
  return dispatch =>
    rootRef
      .child("ventas/colegios_localidad")
      .once("value", snap =>
        dispatch(actions.obtenerLocalidades(Object.values(snap.val())))
      );
}

function limpiarLocalidades() {
  return actions.limpiarLocalidades();
}

/* -- Paginación General -- */
function obtenerDatosPaginacionGeneral({
  itemsPorPagina = 20,
  provinciaActiva = "",
  idColegio,
  localidadBuscada
}) {
  return dispatch =>
    getMainRef({ provinciaActiva, idColegio, localidadBuscada }).once(
      "value",
      snap => {
        const total = snap.numChildren();
        dispatch(actions.itemsTotales(total));

        const pags =
          total % itemsPorPagina > 0
            ? Math.round(total / itemsPorPagina)
            : total / itemsPorPagina;

        dispatch(actions.paginasTotales(pags));
      }
    );
}

function itemsPorPagina(payload) {
  return actions.itemsPorPagina(payload);
}

function setTipoListado(payload) {
  return actions.setTipoListado(payload);
}

function obtenerPagina({
  itemsPorPagina = 20,
  tipo,
  pagina = 1,
  provinciaActiva = "",
  idColegio = null,
  localidadBuscada = ""
}) {
  return dispatch => {
    dispatch(actions.limpiarAccionesDeVenta());

    tipo === "general"
      ? dispatch(
          obtenerPaginaGeneral({
            itemsPorPagina,
            pagina,
            provinciaActiva,
            idColegio,
            localidadBuscada
          })
        )
      : dispatch(
          obtenerPaginaPorTipo({
            itemsPorPagina,
            tipo,
            provinciaActiva,
            localidadBuscada
          })
        );
  };
}

function getReferenciaFirebase({
  provinciaActiva,
  itemsPorPagina,
  pageIndexes,
  pagina,
  idColegio,
  localidadBuscada
}) {
  return provinciaActiva
    ? rootRef
        .child(`ventas/colegios_por_provincia/${provinciaActiva}`)
        .orderByKey()
        .limitToFirst(itemsPorPagina)
        .startAt(pageIndexes[pagina - 1])
    : localidadBuscada
      ? rootRef
          .child(`ventas/colegios_por_localidad/lista/${localidadBuscada}`)
          .orderByKey()
          .limitToFirst(itemsPorPagina)
          .startAt(pageIndexes[pagina - 1])
      : idColegio
        ? rootRef
            .child("ventas/colegios")
            .orderByKey()
            .equalTo(idColegio)
        : rootRef
            .child("ventas/colegios")
            .orderByKey()
            .limitToFirst(itemsPorPagina)
            .startAt(pageIndexes[pagina - 1]);
}

function getMainRef({ provinciaActiva, idColegio, localidadBuscada }) {
  return provinciaActiva
    ? rootRef.child(`ventas/colegios_por_provincia/claves/${provinciaActiva}`)
    : localidadBuscada
      ? rootRef.child(
          `ventas/colegios_por_localidad/claves/${localidadBuscada}`
        )
      : idColegio
        ? rootRef
            .child("ventas/colegios_keys")
            .orderByKey()
            .equalTo(idColegio)
        : rootRef.child("ventas/colegios_keys");
}

function obtenerPaginaGeneral({
  itemsPorPagina,
  pagina,
  provinciaActiva = "",
  idColegio = null,
  localidadBuscada
}) {
  return dispatch => {
    const mainRef = getMainRef({
      provinciaActiva,
      idColegio,
      localidadBuscada
    });

    mainRef.once("value", snapp => {
      const claves = Object.keys(snapp.val());
      let pageIndexes = chunk(claves, itemsPorPagina).map(
        item => item.slice(0, 1)[0]
      );

      const dataRef = getReferenciaFirebase({
        provinciaActiva,
        itemsPorPagina,
        pageIndexes,
        pagina,
        idColegio,
        localidadBuscada
      });

      dataRef.on("child_added", snap => {
        let payload = snap.val();

        let prom = [
          rootRef
            .child("ventas/personas_de_contacto")
            .orderByChild("idColegio")
            .equalTo(payload.idColegio)
            .limitToLast(1)
            .once("value"),

          rootRef
            .child("ventas/acciones_de_venta")
            .orderByChild("idColegio")
            .equalTo(payload.idColegio)
            .limitToLast(1)
            .once("value"),

          rootRef
            .child("ventas/tareas_de_venta")
            .orderByChild("idColegio")
            .equalTo(payload.idColegio)
            .limitToLast(1)
            .once("value"),

          rootRef
            .child("ventas/citas_de_venta")
            .orderByChild("idColegio")
            .equalTo(payload.idColegio)
            .limitToLast(1)
            .once("value")
        ];

        Promise.all(prom)
          .then(respuestas => {
            const personasContacto = respuestas[0].val();
            const accionesVenta = respuestas[1].val();
            const tareasVenta = respuestas[2].val();
            const citasVenta = respuestas[3].val();

            payload.hasContactos = personasContacto !== null;
            payload.hasAccionesVenta = accionesVenta !== null;
            payload.hasTareas = tareasVenta !== null;
            payload.hasCitas = citasVenta !== null;
            payload.citaVenta =
              citasVenta !== null
                ? extractInfoFromObject(citasVenta, "fecha_cita")
                : "";

            payload.hasAccionesVenta &&
              dispatch(
                attachAccionesDeVenta({
                  idColegio: payload.idColegio,
                  tipo: "general"
                })
              );

            dispatch(actions.obtenerListaColegios(payload));
          })
          .catch(error => console.log(error));
      });
    });
  };
}

function extractInfoFromObject(object, info) {
  let { 0: newObject } = Object.values(object);
  return newObject[info];
}
function cambiarEstadoVenta({ estado, idColegio }) {
  return dispatch => {
    let insert = {};
    insert[`ventas/colegios/${idColegio}/estadoVenta`] = estado;
    rootRef.update(insert);
  };
}
/* --  Paginación por Tipo  -- */

function obtenerDatosPaginacionPorTipo({ itemsPorPagina = 20, tipo }) {
  return dispatch =>
    rootRef
      .child("ventas/acciones_de_venta")
      .orderByChild("tipo")
      .equalTo(tipo)
      .once("value", snap => {
        const total = snap.numChildren();
        dispatch(actions.itemsTotales(total));
        dispatch(actions.paginasTotales(Math.trunc(total / itemsPorPagina)));
      });
}

function obtenerPaginaPorTipo({ itemsPorPagina, tipo }) {
  return dispatch => {
    rootRef
      .child("ventas/acciones_de_venta")
      .orderByChild("tipo")
      .equalTo(tipo)
      .on("child_added", snap => {
        let accion = snap.val();

        let prom = [
          rootRef
            .child("ventas/personas_de_contacto")
            .orderByChild("idColegio")
            .equalTo(accion.idColegio)
            .once("value"),
          rootRef
            .child("ventas/tareas_de_venta")
            .orderByChild("idColegio")
            .equalTo(accion.idColegio)
            .once("value"),
          rootRef
            .child("ventas/colegios")
            .orderByChild("idColegio")
            .equalTo(accion.idColegio)
            .once("value"),
          rootRef
            .child("ventas/citas_de_venta")
            .orderByChild("idColegio")
            .equalTo(accion.idColegio)
            .once("value")
        ];

        Promise.all(prom)
          .then(respuestas => {
            const personasContacto = respuestas[0].val();
            const tareasVenta = respuestas[1].val();
            const colegio = Object.values(respuestas[2].val())[0];
            const citasVenta = respuestas[3].val();

            colegio.hasContactos = personasContacto !== null;
            colegio.hasTareas = tareasVenta !== null;
            colegio.hasCitas = citasVenta !== null;

            dispatch(
              attachAccionesDeVenta({ idColegio: accion.idColegio, tipo })
            );

            dispatch(actions.obtenerListaColegios(colegio));
          })
          .catch(error => console.log(error));
      });
  };
}

function detachPaginacion() {
  return dispatch => {
    rootRef.child("ventas/colegios").off("child_added");
    rootRef.child("ventas/acciones_de_venta").off("child_added");
  };
}
/* -- -- */

function seleccionarColegio(idColegio) {
  return dispatch =>
    rootRef
      .child(`ventas/colegios/${idColegio}`)
      .once(
        "value",
        snap =>
          snap.hasChildren() && dispatch(actions.seleccionarColegio(snap.val()))
      );
}

function quitarColegioSeleccionado() {
  return actions.quitarColegioSeleccionado();
}

function resetDataSaved() {
  return actions.resetDataSaved();
}

/* -- Acciones de Venta -- */
function addAccionDeVenta({
  uid,
  tipo,
  colegio: { idColegio, nombreColegio, provincia, localidad },
  personaId,
  personaNombre,
  personaFormaContacto
}) {
  return dispatch => {
    const accion = {
      idAccion: rootRef.child("ventas/acciones_de_venta").push().key,
      idColegio,
      nombreColegio,
      provincia,
      localidad,
      uid,
      timestamp: new Date().getTime(),
      colegio_tipo: `${idColegio}/${tipo}`,
      nota: "",
      resultado: RESULTADO_ACCION_MAIL.SIN_RESPUESTA,
      tipo,
      personaId,
      personaNombre,
      personaFormaContacto,
      open: true
    };

    rootRef
      .child("ventas/acciones_de_venta")
      .orderByChild("idColegio")
      .equalTo(idColegio)
      .once("value", snap => {
        let insert = {};
        if (snap.hasChildren()) {
          const acciones = Object.keys(snap.val());
          acciones.forEach(
            accion =>
              (insert[`ventas/acciones_de_venta/${accion}/open`] = false)
          );
        }
        insert[`ventas/acciones_de_venta/${accion.idAccion}`] = accion;
        rootRef.update(insert);
      });
  };
}

function cambiarResultadoAccion({ idAccion, resultado }) {
  return dispatch => {
    let insert = {};
    insert[`ventas/acciones_de_venta/${idAccion}/resultado`] = resultado;
    rootRef.update(insert);
  };
}

function cerrarAccionDeVenta({ idAccion, idColegio, open }) {
  return dispatch => {
    let insert = {};
    insert[`ventas/acciones_de_venta/${idAccion}/open`] = open;
    rootRef.update(insert);
  };
}

function attachAccionesDeVenta({ idColegio, tipo }) {
  return dispatch => {
    let child = tipo === "general" ? "idColegio" : "colegio_tipo";
    let equal = tipo === "general" ? idColegio : `${idColegio}/${tipo}`;
    let limit = tipo === "general" ? 1 : 25;

    dispatch(attachOnAddedAccionesDeVenta({ idColegio, child, equal, limit }));
    dispatch(
      attachOnChangedAccionesDeVenta({ idColegio, child, equal, limit })
    );
    dispatch(
      attachOnRemovedAccionesDeVenta({ idColegio, child, equal, limit })
    );
  };
}

function attachOnAddedAccionesDeVenta({ idColegio, child, equal, limit = 25 }) {
  return dispatch =>
    rootRef
      .child(`ventas/acciones_de_venta`)
      .orderByChild(child)
      .equalTo(equal)
      .limitToLast(limit)
      .on("child_added", snap =>
        dispatch(actions.addedAccionesDeVenta(snap.val()))
      );
}

function attachOnChangedAccionesDeVenta({
  idColegio,
  child,
  equal,
  limit = 25
}) {
  return dispatch =>
    rootRef
      .child(`ventas/acciones_de_venta`)
      .orderByChild(child)
      .equalTo(equal)
      .limitToLast(limit)
      .on("child_changed", snap =>
        dispatch(actions.addedAccionesDeVenta(snap.val()))
      );
}

function attachOnRemovedAccionesDeVenta({
  idColegio,
  child,
  equal,
  limit = 25
}) {
  return dispatch => {
    rootRef
      .child(`ventas/acciones_de_venta`)
      .orderByChild(child)
      .equalTo(equal)
      .limitToLast(limit)
      .on("child_removed", snap =>
        dispatch(actions.removedAccionesDeVenta(snap.val()))
      );
  };
}

function detachAccionesDeVenta({ idColegio }) {
  return dispatch => {
    rootRef.child("ventas/acciones_de_venta").off("child_added");
    rootRef.child("ventas/acciones_de_venta").off("child_changed");
    rootRef.child("ventas/acciones_de_venta").off("child_removed");
  };
}

function guardarNotaAccionDeVenta({ idAccion, value }) {
  return dispatch => {
    let insert = {};
    insert[`ventas/acciones_de_venta/${idAccion}/nota`] = value;
    rootRef.update(insert);
  };
}

function setProvinciaActiva({ name }) {
  return actions.setProvinciaActiva(name);
}

function resetProvinciaActiva() {
  return actions.resetProvinciaActiva();
}

function setColegioBuscado({ idColegio }) {
  return actions.setColegioBuscado(idColegio);
}

function resetColegioBuscado() {
  return actions.resetColegioBuscado();
}

function setLocalidadBuscada({ localidad_provincia }) {
  return actions.setLocalidadBuscada(localidad_provincia);
}

function resetLocalidadBuscada() {
  return actions.resetLocalidadBuscada();
}

/*---*/
export {
  resetListaColegios,
  obtenerDatosPaginacion,
  obtenerPagina,
  itemsPorPagina,
  setTipoListado,
  seleccionarColegio,
  quitarColegioSeleccionado,
  resetDataSaved,
  addAccionDeVenta,
  cambiarResultadoAccion,
  attachAccionesDeVenta,
  detachAccionesDeVenta,
  cerrarAccionDeVenta,
  detachPaginacion,
  guardarNotaAccionDeVenta,
  setProvinciaActiva,
  resetProvinciaActiva,
  obtenerNombreColegios,
  limpiarNombreColegios,
  obtenerLocalidades,
  limpiarLocalidades,
  setColegioBuscado,
  resetColegioBuscado,
  cambiarEstadoVenta,
  setLocalidadBuscada,
  resetLocalidadBuscada
};



// WEBPACK FOOTER //
// ./src/ducks/ventas/operations.js